<fa-layers>
   <!-- icon for border -->
   <fa-icon [icon]="skillColorBorderIcon" class="skillConfigurationBorder"></fa-icon>

   <!-- icon for a single skill -->
   <fa-icon
      *ngIf="!skills || skills.length <= 1"
      [icon]="skillColorIcon"
      [style.color]="skillConfiguration?.skillColor | safeStyle"
   ></fa-icon>

   <!-- icon for a skillgroup -->
   <fa-icon *ngIf="skills && skills.length > 1" [icon]="skillColorIcon" class="skillGroupConfiguration"></fa-icon>
</fa-layers>
